import * as React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

const loading = () => (
    <LinearProgress className='loader__linear-progress' color="primary" />
);
export default loading;
